export const ModalCloseButtonUat = {
  closeButton: 'modal.closeButton',
}
